var map = {
	"./01Boton_02.svg": "f572",
	"./02Boton_02.svg": "a5bb",
	"./Boton_direccion.svg": "1ea6",
	"./Boton_fb.svg": "526f",
	"./Boton_flechader.svg": "8f59",
	"./Boton_flechaiz.svg": "be9a",
	"./Boton_insta.svg": "5fad",
	"./Boton_telefono.svg": "bbbd",
	"./Boton_web.svg": "cd39",
	"./OndasTarjeta02.svg": "2609",
	"./OndasTelefono02.svg": "0b8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44f6";